export default function PHP_substr_compare() {
  return (
    <div>
      <h1>PHP_substr_compare</h1>
    </div>
  );
}
